import React from 'react';
import PropTypes from 'prop-types';
import CollegeTabNav from 'shared/college-profile/containers/college-tab-nav';
import Layout from 'shared/college-profile/containers/layout';
import {connectComponent} from 'shared/college-profile/containers/right-rail';
import CollegeTaggingModal from 'shared/college-profile/containers/college-tagging-modal';
import RightRail from './right-rail';

const ConnectedRightRail = connectComponent(RightRail);

const propTypes = {
  getStudentInfo: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string,
    }).isRequired,
  }).isRequired,
  collegeProfile: PropTypes.shape({
    userInfo: PropTypes.shape({
      isUsCitizenOrResident: PropTypes.bool,
    }).isRequired,
  }).isRequired,
};

const CollegeProfile = ({
  getStudentInfo,
  match,
  collegeProfile: {
    userInfo: {isUsCitizenOrResident},
  },
}) => (
  <Layout
    match={match}
    RightRail={ConnectedRightRail}
    getUserInfo={getStudentInfo}
    showSimilarColleges
  >
    <CollegeTabNav
      RightRail={ConnectedRightRail}
      showCostsAndFinancialAid={isUsCitizenOrResident}
      showTestsSection
      showTestScores
    />
    <CollegeTaggingModal collegeSlug={match.params.slug} />
  </Layout>
);

CollegeProfile.propTypes = propTypes;

export default CollegeProfile;
